import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=7d6ff4d1&scoped=true&"
import script from "./Labs.vue?vue&type=script&lang=js&"
export * from "./Labs.vue?vue&type=script&lang=js&"
import style0 from "./Labs.vue?vue&type=style&index=0&id=7d6ff4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ff4d1",
  null
  
)

export default component.exports